import React from 'react';

/**
 * StatCard — карточка статистики.
 *
 * @param {React.ReactNode} icon
 * @param {string|number} value
 * @param {string} label
 * @param {string} iconColor — CSS-цвет иконки (по умолчанию accent-primary)
 * @param {string} iconBg — CSS-цвет фона иконки
 * @param {function} onClick — если передан, карточка становится кнопкой навигации
 */
const StatCard = ({
  icon,
  value,
  label,
  iconColor = 'var(--bm-accent-primary)',
  iconBg = 'rgba(108, 99, 255, 0.12)',
  className = '',
  onClick,
  ...rest
}) => {
  const isInteractive = typeof onClick === 'function';
  const Component = isInteractive ? 'button' : 'div';
  const classes = [
    'bm-stat-card',
    isInteractive ? 'bm-stat-card--interactive' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component
      className={classes}
      onClick={onClick}
      type={isInteractive ? 'button' : undefined}
      {...rest}
    >
      <div
        className="bm-stat-card__icon"
        style={{ color: iconColor, background: iconBg }}
      >
        {icon}
      </div>
      <div>
        <div className="bm-stat-card__value">{value ?? '—'}</div>
        <div className="bm-stat-card__label">{label}</div>
      </div>
    </Component>
  );
};

export default StatCard;
